import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Este componente es un "wrapper" o "envoltura"
// Recibe como prop el componente que queremos proteger (`children`)
function ProtectedRoute({ children }) {
  const { isLoggedIn } = useAuth(); // Usamos nuestro contexto para ver si el usuario está logueado

  // Si el usuario NO ha iniciado sesión...
  if (!isLoggedIn) {
    // ...lo redirigimos a la página de login.
    // `Maps` es un componente de react-router-dom que hace la redirección.
    return <Navigate to="/login" />;
  }

  // Si el usuario SÍ ha iniciado sesión, simplemente mostramos el componente protegido.
  return children;
}

export default ProtectedRoute;